import { render, staticRenderFns } from "./SubscriptionPlanItem.vue?vue&type=template&id=a0cdee0c&scoped=true"
import script from "./SubscriptionPlanItem.vue?vue&type=script&lang=ts"
export * from "./SubscriptionPlanItem.vue?vue&type=script&lang=ts"
import style0 from "./SubscriptionPlanItem.vue?vue&type=style&index=0&id=a0cdee0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cdee0c",
  null
  
)

export default component.exports